import { IContentItemFragment, IContentItemWriterFragment, IContentWriterFragment } from 'src/graphql/generated/hooks'

import { ContentDataFragment, isContentItem, isContentListItemFragment } from './ContentDataFragment'

/** Max two writers supported per article (CMS + Elasticsearch). */
export const MAX_CONTENT_WRITERS = 2

export type NormalizedWriter = IContentWriterFragment | IContentItemWriterFragment | string

export function normalizeWritersList(writer: unknown): NormalizedWriter[] {
  if (writer == null) return []
  const arr = (Array.isArray(writer) ? writer : [writer]) as NormalizedWriter[]
  return arr.filter((w) => w != null && w !== '').slice(0, MAX_CONTENT_WRITERS)
}

/** Resolves writers from list/detail/search shapes used across the app. */
export function normalizeContentWritersFromItem(item: ContentDataFragment): NormalizedWriter[] {
  if (isContentListItemFragment(item)) {
    return normalizeWritersList(item.writer)
  }
  if (isContentItem(item)) {
    const extended = item as IContentItemFragment & { writers?: IContentItemWriterFragment[] | null }
    if (extended.writers && extended.writers.length > 0) {
      return normalizeWritersList(extended.writers)
    }
    return extended.writer ? normalizeWritersList([extended.writer]) : []
  }
  return []
}
